import { Link } from "wouter";
import { useTerritory } from "@/contexts/TerritoryContext";
import { AppStoreBadge } from "@/components/AppStoreBadges";
import logoUrl from "@assets/edufocal-logo-min-50292a59_1758905778671.png";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://instagram.com/edufocal",
    hoverBg: "hover:bg-[#E1306C]",
    testId: "link-instagram",
    icon: (
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    ),
  },
  {
    name: "X / Twitter",
    href: "https://x.com/edufocal",
    hoverBg: "hover:bg-[#000000]",
    testId: "link-twitter",
    icon: (
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/edufocallimited/",
    hoverBg: "hover:bg-[#0077B5]",
    testId: "link-linkedin",
    icon: (
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/edufocal",
    hoverBg: "hover:bg-[#1877F2]",
    testId: "link-facebook",
    icon: (
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@edufocal",
    hoverBg: "hover:bg-[#FF0000]",
    testId: "link-youtube",
    icon: (
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    ),
  },
];

export default function Footer() {
  const { territory } = useTerritory();

  return (
    <footer className="bg-violet-950 text-white">
      <div className="container py-14 md:py-20 px-4 md:px-6 max-w-7xl mx-auto">

        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-10 lg:gap-12">

          {/* Brand */}
          <div className="space-y-6">
            <a href="/" data-testid="link-footer-home">
              <span className="inline-flex rounded-lg bg-white px-3 py-1.5"><img src={logoUrl} alt="EduFocal" className="h-8 w-auto" data-testid="img-footer-logo" /></span>
            </a>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              {territory.footer.tagline}
            </p>
            {/* Social icons: 3 per row */}
            <div className="flex flex-wrap gap-2.5">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-white/10 ${s.hoverBg} rounded-xl flex items-center justify-center transition-colors`}
                  data-testid={s.testId}
                  aria-label={s.name}
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    {s.icon}
                  </svg>
                </a>
              ))}
            </div>
            {/* iOS app */}
            <div className="space-y-2">
              <p className="text-white/60 text-xs uppercase tracking-wider font-semibold">Get the app</p>
              <AppStoreBadge tone="dark" className="inline-flex" />
            </div>
          </div>

          {/* Explore */}
          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-sm uppercase tracking-wider text-white/90">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="/features" className="text-white/60 hover:text-amber-300 transition-colors">Features</a></li>
              <li><a href="/how-it-works" className="text-white/60 hover:text-amber-300 transition-colors">How It Works</a></li>
              <li><a href="/#pricing" className="text-white/60 hover:text-amber-300 transition-colors">Pricing</a></li>
              <li><a href="/blog" className="text-white/60 hover:text-amber-300 transition-colors">Blog</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-sm uppercase tracking-wider text-white/90">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="https://edufocalgroup.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-amber-300 transition-colors" data-testid="link-edufocal-group">EduFocal Group</a></li>
            </ul>
          </div>

          {/* Support */}
          <div className="text-center md:text-left">
            <h4 className="font-bold mb-4 text-sm uppercase tracking-wider text-white/90" data-testid="text-footer-support-title">Support</h4>
            <ul className="space-y-3 text-sm">
              <li><Link href="/contact" className="text-white/60 hover:text-amber-300 transition-colors" data-testid="link-contact-us">Contact Us</Link></li>
              <li><Link href="/privacy" className="text-white/60 hover:text-amber-300 transition-colors" data-testid="link-privacy-policy">Privacy Policy</Link></li>
              <li><Link href="/terms-conditions" className="text-white/60 hover:text-amber-300 transition-colors" data-testid="link-terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <p className="text-white/40 text-xs sm:text-sm" data-testid="text-footer-copyright">
              &copy; 2012-{new Date().getFullYear()} EduFocal. All rights reserved.
            </p>
          </div>
          <div className="text-xs text-right" data-testid="text-footer-address">
            <p className="text-white/40">The Summit Suite 2014, 16 Chelsea Avenue, Kingston 5, Jamaica</p>
          </div>
        </div>

      </div>
    </footer>
  );
}
